<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col lg="12">
				<b-card>
					<loading :active.sync="hotelHrambeTable_props.isLoading" 
						:is-full-page="false"></loading>
					<div slot="header">
						Seznam hramb
						<div class="card-actions">
							<b-link v-if="!confirmationActive" title="Kontrola" @click.stop="toggleConfirmationActive" class="card-header-action btn-setting"><i class="icon-eyeglass"></i></b-link>
							<b-link v-if="confirmationActive" :class="selectedItems.length > 0 ? 'text-success btnConfirmStatus' : 'text-danger btnConfirmStatus'">{{ selectedItems.length > 0 ? 'Število izbranih hramb ' + selectedItems.length : 'Izbrana mora biti vsaj 1 hramba' }}</b-link>
							<b-link v-if="confirmationActive && selectedItems.length > 0" class="btn btn-primary text-success" title="Potrdi kontrolo" @click.prevent="confirmHotelHrambe"><i class="icon-check"></i></b-link>
							<b-link v-if="confirmationActive" class="btn btn-primary text-danger" title="Ponastavi kontrolo" @click.prevent="resetConfirmations"><i class="icon-trash"></i></b-link>
							<b-link v-if="confirmationActive" class="btn btn-primary text-danger" title="Prekliči kontrolo" @click.prevent="toggleConfirmationActive"><i class="icon-close"></i></b-link>
							<b-link v-if="userCanEdit && !confirmationActive" title="Lokacije" @click.stop="hotelHrambeTableLokacije_click" class="card-header-action btn-setting"><i class="icon-location-pin"></i></b-link>
							<b-link v-if="!confirmationActive" title="Osveži tabelo" @click.stop="hotelHrambeTableRefresh_click" class="card-header-action btn-setting"><i class="icon-refresh"></i></b-link>
							<b-link v-if="!confirmationActive" title="Odstrani filtre" @click.stop="hotelHrambeTableToggleFilter_click" class="card-header-action btn-setting"><i class="icon-close"></i></b-link>
							<b-link v-if="userCanEdit && !confirmationActive" title="Dodaj hrambo" @click.stop="addHotelHotelHramba_click" class="card-header-action btn-setting"><i class="icon-plus"></i></b-link>
						</div>
					</div>
					<b-table
						ref="hotelHrambeTable"
						responsive="sm"
						striped
						show-empty
						hover
						:empty-text="hotelHrambeTable_props.empty_text"
						:empty-filtered-text="hotelHrambeTable_props.empty_filtered_text"
						:sort-desc="false"
						:fields="hotelHrambeTable_props.fields"
						:current-page="hotelHrambeTable_props.page"
						:per-page="hotelHrambeTable_props.size"
						:items="hotelHrambeTable_items"
						:tbody-tr-class="rowClass"
						@row-clicked="hotelHrambeTable_rowClicked">
						<template slot="top-row">
							<td v-if="confirmationActive"></td>
							<td><b-form-input v-model="hotelHrambeTable_props.inputFilter.id" type="number" @input="hotelHrambeTableTextFilter_change"/></td>
							<td><b-form-input v-model="hotelHrambeTable_props.inputFilter.title" type="text" @input="hotelHrambeTableTextFilter_change"/></td>
							<td><b-form-input v-model="hotelHrambeTable_props.inputFilter.registration_number" type="text" @input="hotelHrambeTableTextFilter_change"/></td>
							<td><b-form-input v-model="hotelHrambeTable_props.inputFilter.vehicle" type="text" @input="hotelHrambeTableTextFilter_change"/></td>
							<td><b-form-input v-model="hotelHrambeTable_props.inputFilter.hotelLokacija" type="text" @input="hotelHrambeTableTextFilter_change"/></td>
							<td><external-filter-dropdown ref="externalFilterDropdown" v-model="hotelHrambeTable_props.inputFilter.external" @input="hotelHrambeTableFilter_change" /></td>
							<td><season-filter-dropdown ref="seasonDropdown" @change="on_seasonFilterChange" /></td>
							<td><datum-filter-dropdown v-model="hotelHrambeTable_props.inputFilter.datumStoritve" @input="hotelHrambeTableFilter_change" v-bind:noFutureValues="true"/></td>
							<td>
								<b-form inline>
									<b-form-input v-model="hotelHrambeTable_props.inputFilter.dimensionsWidth" type="number" @input="hotelHrambeTableTextFilter_change" class="dimensionsWidthInputFilter mr-1 p-1"/>/
									<b-form-input v-model="hotelHrambeTable_props.inputFilter.dimensionsHeight" type="number" @input="hotelHrambeTableTextFilter_change" class="dimensionsHeightDiameterInputFilter mr-1 ml-1 p-1"/>R
									<b-form-input v-model="hotelHrambeTable_props.inputFilter.dimensionsDiameter" type="number" @input="hotelHrambeTableTextFilter_change" class="dimensionsHeightDiameterInputFilter ml-1 p-1"/>
								</b-form>
							</td>
							<td><status-hotel-hramba-dropdown ref="statusHotelHrambaFilterDropdown" v-model="hotelHrambeTable_props.inputFilter.statusHotelHramba" @input="hotelHrambeTableFilter_change" /></td>
							<td v-if="!confirmationActive"></td>
						</template>
						<template slot="selected" slot-scope="data">
							<b-form-checkbox :disabled="data.item.date_confirmed != null" :checked="data.item.date_confirmed != null ? true : data.item.selected" @change="selectItem_change(data.item)"></b-form-checkbox>
						</template>
						<template slot="id" slot-scope="data">
							<b>{{ data.item.id }}</b>
						</template>
						<template slot="hotel_stranka_external" slot-scope="data">
							<div v-if="data.item.hotel_stranka_external === 0">Ne</div>
							<div v-else-if="data.item.hotel_stranka_external === 1">Da</div>
							<div v-else> / </div>
						</template>
						<template slot="hotel_storitev_season" slot-scope="data">
							<div v-if="data.item.hotel_storitev_season !== null">{{ getSeasonLabel(data.item.hotel_storitev_season) }}</div>
							<div v-else>/</div>
						</template>
						<template slot="hotel_storitev_date_give" slot-scope="data">
							<div v-if="data.item.hotel_storitev_date_give !== null">{{ data.item.hotel_storitev_date_give | hr_date }}</div>
							<div v-else>/</div>
						</template>
						<template slot="hotel_storitev_dimensions" slot-scope="data">
							<div v-if="data.item.hotel_storitev_dimensions !== null">{{ getDemensionsLabel(data.item.hotel_storitev_dimensions) }}</div>
							<div v-else>/</div>
						</template>
						<template slot="status" slot-scope="data">
							<b-badge :variant="hotelHrambaStatus(data.item).variant" :class="hotelHrambaStatus(data.item).class" :title="hotelHrambaStatus(data.item).title"> {{ hotelHrambaStatus(data.item).label }}</b-badge>
						</template>
						<template slot="user_confirmed" slot-scope="data">
							<div v-if="data.item.user_confirmed != null">{{ data.item.user_confirmed_first_name }} {{ data.item.user_confirmed_last_name }}</div>
						</template>
						<template slot="actions" slot-scope="data">
							<div>
								<b-button v-if="userCanEdit && data.item.fk_hotel_lokacija && data.item.fk_hotel_stranka && data.item.hotel_storitev_id !== null" title="Menjava pnevmatik"  ref="hotelHrambaAddSwitch" class="m-1 seznamHotelHrambIconStyle" variant="success" @click.stop="hotelHrambaAddSwitch_click(data.item)" size="sm">
									<i class="fa fa-arrows-h"></i>
								</b-button>
								<b-button v-if="userCanEdit && data.item.fk_hotel_lokacija && data.item.fk_hotel_stranka && data.item.hotel_storitev_id !== null" title="Izdaja pnevmatik"  ref="hotelHrambaAddTake" class="m-1 seznamHotelHrambIconStyle" variant="warning" @click.stop="hotelHrambaAddTake_click(data.item)" size="sm">
									<i class="fa fa-long-arrow-left"></i>
								</b-button>
								<b-button v-if="userCanEdit && data.item.fk_hotel_lokacija && data.item.fk_hotel_stranka && data.item.hotel_storitev_id === null" title="Oddaja pnevmatik"  ref="hotelHrambaAddGive" class="m-1 seznamHotelHrambIconStyle lightWarning" variant="warning" @click.stop="hotelHrambaAddGive_click(data.item)" size="sm">
									<i class="fa fa-long-arrow-right"></i>
								</b-button>
								<b-button v-if="data.item.fk_hotel_lokacija && data.item.fk_hotel_stranka" :title="userCanEdit ? 'Uredi storitve' : 'Poglej storitve'"  ref="hotelHrambaManageStoritve" class="m-1 seznamHotelHrambIconStyle" variant="info" @click.stop="hotelHrambaManageStorive_click(data.item)" size="sm">
									<i class='fa fa-cog'></i>
								</b-button>
								<b-button :title="userCanEdit ? 'Uredi hrambo' : 'Poglej hrambo'" ref="hotelHrambaEdit" class="m-1 seznamHotelHrambIconStyle" variant="primary" @click.stop="hotelHrambaEdit_click(data.item)" size="sm">
									<i :class="userCanEdit ? 'fa fa-pencil-square-o' : 'fa fa-search-plus'"></i>
								</b-button>
							</div>
						</template>
					</b-table>
					<nav class="nav">
						<b-row>
							<b-col>
								<b-pagination :total-rows="hotelHrambeTable_props.total" :per-page="hotelHrambeTable_props.size" v-model="hotelHrambeTable_props.page" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
							</b-col>
							<b-col>
								<a class="page-link rows_total">Št. vrstic: {{ hotelHrambeTable_props.total }}</a>
							</b-col>
							<b-col>
								<b-form-select v-model="hotelHrambeTable_props.size" :options="hotelHrambeTable_props.options_numRowsOnPage"></b-form-select>
							</b-col>
						</b-row>
					</nav>
				</b-card>
			</b-col>
		</b-row>
		<edit-hotel-hramba-modal :hotelStranke="hotelStranke_options" v-bind:hotelStoritevDistincManufacturers="hotelStoritevDistincManufacturers" ref="editHotelHrambaModal" @emit_success="emit_edit_hotel_hramba" @emit_hotelStranke_changed="emit_hotelStranke_changed" @emit_hotelStoritev_changed="emit_hotelStoritev_changed"/>
		<hotel-lokacije-modal ref="hotelLokacijeModal"/>
		<edit-hotel-storitev-modal v-bind:hotelStoritevDistincManufacturers="hotelStoritevDistincManufacturers" ref="editHotelStoritevModal" @emit_success="emit_edit_hotel_storitev"/>
		<vue-toastr ref="toastr"></vue-toastr>
	</div>
</template>

<script>
import service from '@/service';
import settings from '@/settings.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import EditHotelHrambaModal from '@/components/HotelGum/Modals/EditHotelHrambaModal';
import HotelLokacijeModal from '@/components/HotelGum/Modals/HotelLokacijeModal';
import EditHotelStoritevModal from '@/components/HotelGum/Modals/EditHotelStoritevModal';
import ExternalFilterDropdown from '@/components/DropdownFilters/ExternalFilterDropdown';
import SeasonFilterDropdown from '@/components/DropdownFilters/SeasonFilterDropdown';
import DatumFilterDropdown from '@/components/DatumFilterDropdown';
import StatusHotelHrambaFilterDropdown from '@/components/DropdownFilters/StatusHotelHrambaFilterDropdown';

export default {
	name: 'hotelGum',
	components: {
		Loading,
		'edit-hotel-hramba-modal': EditHotelHrambaModal,
		'hotel-lokacije-modal': HotelLokacijeModal,
		'edit-hotel-storitev-modal': EditHotelStoritevModal,
		'external-filter-dropdown': ExternalFilterDropdown,
		'season-filter-dropdown': SeasonFilterDropdown,
		'datum-filter-dropdown': DatumFilterDropdown,
		'status-hotel-hramba-dropdown': StatusHotelHrambaFilterDropdown
	},
	filters: {
	},
	methods: {
		hotelHrambeTableFilter_change: function (value) {
			this.$refs.hotelHrambeTable.refresh();
		},
		hotelHrambeTableTextFilter_change: function (value) {
			if (this.hotelHrambeTable_props.textFilterTimeout !== null) {
				clearTimeout(this.hotelHrambeTable_props.textFilterTimeout);
			}
			this.hotelHrambeTable_props.textFilterTimeout = setTimeout(() => {
				this.$refs.hotelHrambeTable.refresh();
			}, settings.filterTimeoutLength);
		},
		hotelHrambeTableRefresh_click: function () {
			this.$refs.hotelHrambeTable.refresh();
		},
		hotelHrambeTableToggleFilter_click: function () {
			this.hotelHrambeTable_props.inputFilter.id = null;
			this.hotelHrambeTable_props.inputFilter.title = null;
			this.hotelHrambeTable_props.inputFilter.email = null;
			this.hotelHrambeTable_props.inputFilter.registration_number = null;
			this.hotelHrambeTable_props.inputFilter.vehicle = null;
			this.hotelHrambeTable_props.inputFilter.hotelLokacija = null;
			this.hotelHrambeTable_props.inputFilter.external = null;
			this.hotelHrambeTable_props.inputFilter.datumStoritve = null;
			this.hotelHrambeTable_props.inputFilter.dimensionsWidth = null;
			this.hotelHrambeTable_props.inputFilter.dimensionsHeight = null;
			this.hotelHrambeTable_props.inputFilter.dimensionsDiameter = null;
			this.$refs.externalFilterDropdown.click_Vse();
			this.$refs.hotelHrambeTable.refresh();
		},
		hotelHrambeTable_items: function (ctx) {
			this.hotelHrambeTable_props.isLoading = true;
			return service.getHotelHrambeFiltered(ctx, this.hotelHrambeTable_props.inputFilter)
				.then(responseData => {
					this.hotelHrambeTable_props.isLoading = false;
					if (responseData.message === 'success') {
						this.hotelHrambeTable_props.empty_text = 'Ni vnosov';
						this.hotelHrambeTable_props.total = responseData.items.total;
						for (let hotelHramba of this.selectedItems) {
							let alreadySelectedItem = responseData.items.data.find(item => item.id === hotelHramba.id);
							if (alreadySelectedItem != null) {
								alreadySelectedItem.selected = true;
							}
						}
						// this.$refs.editHotelHrambaModal.showModal(3, responseData.items.data.find(element => element.id === 11)); // Manage storitve HotelHramba
						return responseData.items.data;
					} else {
						this.$refs.toastr.e('Neveljaven odziv strežnika.');
						this.hotelHrambeTable_props.empty_text = 'Napaka pri pridobivanju hramb';
						this.hotelHrambeTable_props.total = 0;
						console.error('Neveljaven odziv strežnika: ', responseData.message);
						return [];
					}
				})
				.catch(error => {
					this.hotelHrambeTable_props.isLoading = false;
					if (error.response) {
						// Request made and server responded
						if (error.response.status === 400) {
							if (error.response.data.internalCode === 600) {
								this.$refs.toastr.e('Neznana napaka na strežniku!');
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 601) {
								this.$refs.toastr.e('Napaka pri podatkovni bazi!');
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 602) {
								this.$refs.toastr.e('Uporabnik nima dostopa do Hotela gum!');
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 603) {
								this.$refs.toastr.e('Napaka pri validaciji na strežniku!');
								console.error(error.response.data.message);
							} else {
								this.$refs.toastr.e('Neznana napaka na strežniku (status: ' + error.response.status + ')!');
								console.error(error.response.data.internalCode, error.response.data.message);
							}
						} else {
							this.$refs.toastr.e('Neznana napaka na strežniku (status: ' + error.response.status + ')!');
							console.error(error.response.status, error.response.data.message);
						}
					} else if (error.request) {
						// The request was made but no response was received
						this.$refs.toastr.e('Napaka: strežnik se ni odzval!');
						console.error('The request was made but no response was received:', error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						this.$refs.toastr.e('Napaka pri pošiljanju zahteve na strežnik!');
						console.error('Something happened in setting up the request that triggered an Error:', error.message);
					}
					this.hotelHrambeTable_props.empty_text = 'Napaka pri pridobivanju hramb';
					this.hotelHrambeTable_props.total = 0;
					return [];
				});
		},
		hotelHrambeTable_rowClicked: function (item, index) {
			if (this.confirmationActive) {
				this.selectItem_change(item);
			} else {
				if (item.fk_hotel_stranka && item.fk_hotel_lokacija) {
					this.$refs.editHotelHrambaModal.showModal(3, item); // Manage storitve HotelHramba
				} else {
					this.$refs.editHotelHrambaModal.showModal(2, item); // Editing HotelHramba
				}
			}
		},
		addHotelHotelHramba_click: function () {
			this.$refs.editHotelHrambaModal.showModal(1, null); // Adding HotelHramba
		},
		hotelHrambaEdit_click: function (item) {
			this.$refs.editHotelHrambaModal.showModal(2, item); // Editing HotelHramba
		},
		hotelHrambaManageStorive_click: function (item) {
			this.$refs.editHotelHrambaModal.showModal(3, item); // Manage storitve HotelHramba
		},
		emit_edit_hotel_hramba: function (hramba, mode, actionCommited) {
			if (mode === 1) { // dodajanje
				this.$refs.toastr.s('Hramba št. ' + hramba.id + ' uspešno dodana.');
				this.$refs.hotelHrambeTable.refresh();
			} else if (mode === 2) { // urejanje
				this.$refs.toastr.s('Hramba št. ' + hramba.id + ' uspešno urejena.');
				this.$refs.hotelHrambeTable.refresh();
			} else if (mode === 3) { // manage storitve
				if (actionCommited) {
					this.$refs.hotelHrambeTable.refresh();
				}
			} else { // neznana akcija
				console.error('Neznana akcija emit_edit_hotel_hramba', hramba, mode);
			}
		},
		emit_hotelStranke_changed: function () {
			this.$refs.hotelHrambeTable.refresh();
			this.initializeHotelStranke();
		},
		emit_hotelStoritev_changed: function () {
			this.$refs.hotelHrambeTable.refresh();
		},
		hotelHrambeTableLokacije_click: function () {
			this.$refs.hotelLokacijeModal.showModal(1); // Normal HotelLokacije
		},
		hotelHrambaStatus: function (item) {
			if (item.fk_hotel_lokacija && item.fk_hotel_stranka) {
				return {
					label: 'Zasedena',
					variant: 'warning',
					class: '',
					title: 'Hramba ima stranko in lokacijo'
				}
			} else if (item.fk_hotel_lokacija && !item.fk_hotel_stranka) {
				return {
					label: 'Prosta',
					variant: 'success',
					class: '',
					title: 'Hramba ima samo lokacijo'
				}
			} else if (!item.fk_hotel_lokacija && item.fk_hotel_stranka) {
				return {
					label: 'Prosta',
					variant: 'success',
					class: '',
					title: 'Hramba ima samo stranko'
				}
			} else {
				return {
					label: 'Prosta',
					variant: 'success',
					class: '',
					title: 'Hramba nima lokacije in stranke'
				}
			}
		},
		hotelHrambaAddGive_click: function (item) {
			let modalInput = {
				mode: 1,
				hotelStoritev: null,
				hotelHramba: item
			}
			this.$refs.editHotelStoritevModal.showModal(modalInput); // Add new give to HotelHramba
		},
		hotelHrambaAddTake_click: function (item) {
			let activeHotelStoritev = {
				id: item.hotel_storitev_id,
				fk_hotel_hramba: item.hotel_storitev_fk_hotel_hramba,
				fk_hotel_stranka: item.hotel_storitev_fk_hotel_stranka,
				num_tires: item.hotel_storitev_num_tires,
				dimensions: item.hotel_storitev_dimensions,
				manufacturer: item.hotel_storitev_manufacturer,
				season: item.hotel_storitev_season,
				rims: item.hotel_storitev_rims,
				rims_cover: item.hotel_storitev_rims_cover,
				rims_screw: item.hotel_storitev_rims_screw,
				wear: item.hotel_storitev_year,
				note_give: item.hotel_storitev_note_give,
				responsible_mechanic_give: item.hotel_storitev_responsible_mechanic_give,
				date_give: item.hotel_storitev_date_give,
				note_take: item.hotel_storitev_note_take,
				responsible_mechanic_take: item.hotel_storitev_date_take,
				date_take: item.hotel_storitev_fk_hotel_hramba,
				fk_hotel_storitev_take: item.hotel_storitev_fk_hotel_storitev_take,
				fk_hotel_storitev_give: item.hotel_storitev_fk_hotel_storitev_give
			};
			let modalInput = {
				mode: 2,
				hotelStoritev: activeHotelStoritev,
				hotelHramba: item
			}
			this.$refs.editHotelStoritevModal.showModal(modalInput); // Add new give to HotelHramba
		},
		hotelHrambaAddSwitch_click: function (item) {
			let activeHotelStoritev = {
				id: item.hotel_storitev_id,
				fk_hotel_hramba: item.hotel_storitev_fk_hotel_hramba,
				fk_hotel_stranka: item.hotel_storitev_fk_hotel_stranka,
				num_tires: item.hotel_storitev_num_tires,
				dimensions: item.hotel_storitev_dimensions,
				manufacturer: item.hotel_storitev_manufacturer,
				season: item.hotel_storitev_season,
				rims: item.hotel_storitev_rims,
				rims_cover: item.hotel_storitev_rims_cover,
				rims_screw: item.hotel_storitev_rims_screw,
				wear: item.hotel_storitev_year,
				note_give: item.hotel_storitev_note_give,
				responsible_mechanic_give: item.hotel_storitev_responsible_mechanic_give,
				date_give: item.hotel_storitev_date_give,
				note_take: item.hotel_storitev_note_take,
				responsible_mechanic_take: item.hotel_storitev_date_take,
				date_take: item.hotel_storitev_fk_hotel_hramba,
				fk_hotel_storitev_take: item.hotel_storitev_fk_hotel_storitev_take,
				fk_hotel_storitev_give: item.hotel_storitev_fk_hotel_storitev_give,
				hotel_komentarji: item.hotel_storitev_komentarji
			};
			let modalInput = {
				mode: 3,
				hotelStoritev: activeHotelStoritev,
				hotelHramba: item
			}
			this.$refs.editHotelStoritevModal.showModal(modalInput); // Add new switch to HotelHramba
		},
		emit_edit_hotel_storitev: function (storitev, mode) {
			if (mode === 1) { // addGive
				this.$refs.toastr.s('Gume  #' + storitev.id + ' uspešno oddane.');
				this.$refs.hotelHrambeTable.refresh();
			} else if (mode === 2) { // addTake
				this.$refs.toastr.s('Gume  #' + storitev.id + ' uspešno prevzete.');
				this.$refs.hotelHrambeTable.refresh();
			} else if (mode === 3) { // addSwitch
				this.$refs.toastr.s('Zamenjava dodana.');
				this.$refs.hotelHrambeTable.refresh();
			} else { // neznana akcija
				this.$refs.toastr.s('Neznana akcija.');
				console.error('Neznana akcija emit_edit_hotel_storitev', storitev, mode);
			}
		},
		getSeasonLabel: function (season) {
			let selectedOption = settings.season_options.find(element => element.value === season);
			if (selectedOption) {
				return selectedOption.text;
			}
			return '';
		},
		getDemensionsLabel: function (dimensions) {
			dimensions = JSON.parse(dimensions);
			return dimensions.width + '/' + dimensions.heigth + 'R' + dimensions.diameter;
		},
		on_seasonFilterChange: function (selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.hotelHrambeTable_props.inputFilter.season = [];
				for (let item of selectedItems) {
					this.hotelHrambeTable_props.inputFilter.season.push(item.value);
				}
			} else {
				this.hotelHrambeTable_props.inputFilter.season = null;
			}
			this.$refs.hotelHrambeTable.refresh();
		},
		rowClass: function (item) {
			if (!item) {
				return '';
			}
			let result = '';
			if (this.confirmationActive) {
				if (item.date_confirmed == null) {
					result += 'table-danger';
				} else {
					result += 'table-success';
				}
			} else {
				if (this.currentDate >= this.dangerDateZimske && this.currentDate <= this.lineDateZimske && item.hotel_storitev_season === 'Z') {
					result += 'table-danger';
				} else if (this.currentDate >= this.dangerDateLetne && this.currentDate <= this.lineDateLetne && item.hotel_storitev_season === 'L') {
					result += 'table-danger';
				} else if (this.currentDate >= this.warningDateZimske && this.currentDate <= this.lineDateZimske && item.hotel_storitev_season === 'Z') {
					result += 'table-warning';
				} else if (this.currentDate >= this.warningDateLetne && this.currentDate <= this.lineDateLetne && item.hotel_storitev_season === 'L') {
					result += 'table-warning';
				}
			}
			return result;
		},
		setHover: function (item) {
			if (!item) {
				return true;
			}
			if (item.date_confirmed != null) {
				return false;
			}
			return true;
		},
		setCheckingDates: function () {
			this.currentDate = new Date();
			/* ZA TESTIRANJE
			this.currentDate.setMonth(2);
			this.currentDate.setDate(15); */
			this.lineDateZimske = new Date(); // 15. marec
			this.lineDateZimske.setMonth(2);
			this.lineDateZimske.setDate(15);
			this.warningDateZimske = new Date(); // 15. februar
			this.warningDateZimske.setMonth(1);
			this.warningDateZimske.setDate(15);
			this.dangerDateZimske = new Date(); // 1. marec
			this.dangerDateZimske.setMonth(2);
			this.dangerDateZimske.setDate(1);
			this.lineDateLetne = new Date(); // 15. november
			this.lineDateLetne.setMonth(10);
			this.lineDateLetne.setDate(15);
			this.warningDateLetne = new Date(); // 15. oktober
			this.warningDateLetne.setMonth(9);
			this.warningDateLetne.setDate(15);
			this.dangerDateLetne = new Date(); // 1. november
			this.dangerDateLetne.setMonth(10);
			this.dangerDateLetne.setDate(1);
		},
		initializeHotelStranke: function () {
			service.searchHotelStranke('#initialize')
				.then(hotelStranke => {
					this.hotelStranke_options = hotelStranke;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
				});
		},
		toggleConfirmationActive: function () {
			if (this.confirmationActive) {
				this.confirmationActive = false;
				for (let selectedItem of this.selectedItems) {
					selectedItem.selected = false;
				}
				this.selectedItems = [];
				this.hotelHrambeTable_props.fields.shift();
				this.hotelHrambeTable_props.fields.pop();
				this.hotelHrambeTable_props.fields.push({ key: 'actions', label: '#', 'class': 'tdHotelHrambeActions' });
			} else {
				this.confirmationActive = true;
				this.hotelHrambeTable_props.fields.unshift({ key: 'selected', label: '-', sortable: false });
				this.hotelHrambeTable_props.fields.pop();
				this.hotelHrambeTable_props.fields.push({ key: 'user_confirmed', label: 'Potrdil', 'class': '' });
			}
		},
		confirmHotelHrambe: function () {
			if (this.selectedItems.length > 0) {
				this.isLoading = true;
				let data = {
					items: this.selectedItems
				}
				service.hotelHrambaConfirm(data)
					.then(response => {
						this.isLoading = false;
						if (response.message === 'success') {
							this.toggleConfirmationActive();
							if (response.num_confirmation_success > 0) {
								this.$refs.toastr.s('Število potrjenih hramb: ' + response.num_confirmation_success);
							}
							if (response.items_not_found.length > 0) {
								let notFoundString = 'Številke hramb, ki niso bile najdene na strežniku: ';
								for (let item of response.items_not_found) {
									notFoundString += '#' + item.id + ', ';
								}
								notFoundString = notFoundString.substring(-2);
								this.$refs.toastr.e(notFoundString);
							}
							if (response.items_not_saved.length > 0) {
								let notSavedString = 'Številke hramb, ki niso bile uspešno potrjene: ';
								for (let item of response.items_not_saved) {
									notSavedString += '#' + item.id + ', ';
								}
								notSavedString = notSavedString.substring(-2);
								this.$refs.toastr.e(notSavedString);
							}
							this.$refs.hotelHrambeTable.refresh();
						} else {
							this.$refs.toastr.e('Neveljaven odziv strežnika');
							this.$refs.hotelHrambeTable.refresh();
						}
					})
					.catch(error => {
						this.isLoading = false;
						if (error.response) {
							// Request made and server responded
							this.$refs.toastr.e('Napaka pri potrditvi hramb!');
							console.error(error);
						} else if (error.request) {
							// The request was made but no response was received
							this.$refs.toastr.e('Napaka pri potrditvi hramb: strežnik se ni odzval!');
							console.error('The request was made but no response was received:', error.request);
						} else {
							// Something happened in setting up the request that triggered an Error
							this.$refs.toastr.e('Napaka pri pošiljanju zahteve za potrditve hramb na strežnik!');
							console.error('Something happened in setting up the request that triggered an Error:', error.message);
						}
					});
			} else {
				this.$refs.toastr.e('Izbrati morate vsaj eno hrambo!');
			}
		},
		selectItem_change: function (item) {
			console.log(item)
			if (item.date_confirmed == null) {
				item.selected = !item.selected;
				if (item.selected) {
					this.selectedItems.push(item);
				} else {
					this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
				}
				this.$forceUpdate();
			}
		},
		resetConfirmations: function () {
			this.$bvModal.msgBoxConfirm('Ste prepričani, da želite ponastaviti VSE potrditve?', {
				title: 'Potrdite ponastavitev VSEH potrditev',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					this.isLoading = true;
					service.hotelHrambaResetConfirmations()
						.then(response => {
							this.isLoading = false;
							if (response.message === 'success') {
								this.$refs.toastr.s('Potrditve uspešno ponastavljene');
								this.toggleConfirmationActive();
								this.toggleConfirmationActive();
								this.$refs.hotelHrambeTable.refresh();
							} else {
								this.$refs.toastr.e('Neveljaven odziv strežnika');
								this.$refs.hotelHrambeTable.refresh();
							}
						})
						.catch(error => {
							this.isLoading = false;
							if (error.response) {
								// Request made and server responded
								this.$refs.toastr.e('Napaka pri potrditvi hramb!');
								console.error(error);
							} else if (error.request) {
								// The request was made but no response was received
								this.$refs.toastr.e('Napaka pri potrditvi hramb: strežnik se ni odzval!');
								console.error('The request was made but no response was received:', error.request);
							} else {
								// Something happened in setting up the request that triggered an Error
								this.$refs.toastr.e('Napaka pri pošiljanju zahteve za potrditve hramb na strežnik!');
								console.error('Something happened in setting up the request that triggered an Error:', error.message);
							}
						});
				}
			}).catch(err => {
				console.log(err);
			})
		}
	},
	data: () => {
		return {
			settings,
			hotelHrambeTable_props: {
				fields: [
					{ key: 'id', label: 'Št. hrambe', sortable: true, class: 'tdHotelHrambeId' },
					{ key: 'hotel_stranka_title', label: 'Naziv', sortable: true, class: '' },
					{ key: 'hotel_stranka_registration_number', label: 'Registracijska števila', sortable: true, class: '' },
					{ key: 'hotel_stranka_vehicle', label: 'Vozilo', sortable: true, class: '' },
					{ key: 'hotel_lokacija_title', label: 'Lokacija', sortable: false, class: '' },
					{ key: 'hotel_stranka_external', label: 'External', sortable: true, class: 'tdHotelStoritveExternal' },
					{ key: 'hotel_storitev_season', label: 'Sezona', sortable: false, class: '' },
					{ key: 'hotel_storitev_date_give', label: 'Datum', sortable: false, class: 'tdHotelStoritevDatum' },
					{ key: 'hotel_storitev_dimensions', label: 'Dimenzije', sortable: false, class: 'tdHotelStoritevDimensions' },
					{ key: 'status', label: 'Status', class: 'tdHotelHrambeStatus' },
					{ key: 'actions', label: '#', sortable: false, class: 'tdHotelHrambeActions' }
				],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				page: 1,
				size: 1000,
				total: 0,
				isLoading: false,
				inputFilter: {
					id: null,
					title: null,
					email: null,
					registration_number: null,
					vehicle: null,
					external: null,
					season: null,
					hotelLokacija: null,
					datumStoritve: null,
					dimensionsWidth: null,
					dimensionsHeight: null,
					dimensionsDiameter: null,
					statusHotelHramba: null
				},
				textFilterTimeout: null,
				options_numRowsOnPage: [
					{ value: 50, text: '50' },
					{ value: 100, text: '100' },
					{ value: 200, text: '200' },
					{ value: 1000, text: '1000' }
				]
			},
			hotelStoritevDistincManufacturers: [],
			hotelStranke_options: [],
			currentDate: null,
			lineDateZimske: null,
			warningDateZimske: null,
			dangerDateZimske: null,
			lineDateLetne: null,
			warningDateLetne: null,
			dangerDateLetne: null,
			confirmationActive: false,
			selectedItems: []
		};
	},
	computed: {
		user () {
			return this.$store.getters.user;
		},
		userCanEdit () {
			if (settings.isModerator(this.user.role) || settings.isAdmin(this.user.role) || settings.isSkrbnikGum(this.user.role)) {
				return true;
			} else {
				return false;
			}
		}
	},
	created () {
		service.hotelStoritevInitParams({ 'manufacturer': true })
			.then(responseData => {
				if (responseData.message === 'success') {
					this.hotelStoritevDistincManufacturers = responseData.distinctManufacturers;
				} else {
					console.error('Neveljaven odziv strežnika: ', responseData.message);
				}
			})
			.catch(error => {
				if (error.response) {
					// Request made and server responded
					if (error.response.status === 400) {
						if (error.response.data.internalCode === 600) {
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 601) {
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 602) {
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 603) {
							console.error(error.response.data.message);
						} else {
							console.error(error.response.data.internalCode, error.response.data.message);
						}
					} else {
						console.error(error.response.status, error.response.data.message);
					}
				} else if (error.request) {
					// The request was made but no response was received
					console.error('The request was made but no response was received:', error.request);
				} else {
					// Something happened in setting up the request that triggered an Error
					console.error('Something happened in setting up the request that triggered an Error:', error.message);
				}
			});
		this.initializeHotelStranke();
		this.setCheckingDates();
	}
};
</script>
<style scoped>
.table-responsive-sm {
	margin-bottom: 0;
}
.nav {
	border-top: 1px solid #c8ced3;
	padding-top: 1rem;
}
.pagination {
	margin-left: 1rem;
	margin-right: 1rem;
}
.page-link.rows_total {
	text-align: center;
	border-radius: 5px;
	width: 120px;
}
.seznamHotelHrambIconStyle {
	min-width: 35px;
}
.lightWarning {
	background: rgb(248, 225, 134);
}
.dimensionsWidthInputFilter {
	width: 40px;
}
.dimensionsHeightDiameterInputFilter {
	width: 35px;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
<style>
.tdHotelHrambeActions {
	width: 200px;
	max-width: 200px;
	padding: 2px !important;
	text-align: end;
}
.tdHotelHrambeStatus {
	width: 90px;
}
.tdHotelStoritveExternal {
	width: 120px;
}
.tdHotelHrambeId {
	width: 120px;
}
.tdHotelStoritevDatum {
	width: 120px;
}
.tdHotelStoritevDimensions {
	width: 190px;
}
.btnConfirmStatus {
	width: 15.0rem !important;
	padding: 0.75rem 0 0.60rem 0.75rem !important;
}
</style>


// WEBPACK FOOTER //
// src/views/HotelGum.vue